import React, { createContext, useContext, useState } from 'react'
import DrawerViewJSON, { TDrawerViewJSON } from '.'

type TOpenDrawerViewJSON = Pick<TDrawerViewJSON, 'data' | 'title' | 'drawerProps'>

type TProviderDrawerViewJSON = { children: React.ReactNode }

type TProviderDrawerViewJSONContext = {
  openViewJSON: (props: TOpenDrawerViewJSON) => void
  closeViewJSON: () => void
}

export const ViewJSONContext = createContext(undefined) as React.Context<TProviderDrawerViewJSONContext | undefined>;

export const useDrawerViewJSON = (): TProviderDrawerViewJSONContext => {
  const context = useContext(ViewJSONContext)
  if (!context) throw new Error("useDrawerViewJSON must be used inside scope ViewJSONContext.Provider")
  return context
}


export const DrawerViewJSONProvider: React.FC<TProviderDrawerViewJSON> = ({ children }: TProviderDrawerViewJSON) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [drawerProps, setDrawerProps] = useState<TOpenDrawerViewJSON>()

  const openViewJSON = (props: TOpenDrawerViewJSON) => {
    setVisible(true)
    setDrawerProps(props)
  }

  const closeViewJSON = () => {
    setVisible(false)
  }


  const value = { openViewJSON, closeViewJSON }

  return (
    <ViewJSONContext.Provider value={value}>
      <DrawerViewJSON
        {...drawerProps}
        visible={visible}
        onClose={closeViewJSON}
        data={drawerProps?.data}
      />
      {children}
    </ViewJSONContext.Provider>
  )
}

export default DrawerViewJSONProvider
